<div class="btn-group">
  <button nz-button (click)="closePopup($event)">Đóng</button>&nbsp;
  <ng-container *ngIf="isUpdateAndAdd">
    <button nz-button nzType="primary" type="submit" (click)="updateAndAddPopup($event)" [disabled]="isDisableUpdate">Lưu & thêm</button>
  </ng-container>
  <ng-container *ngIf="isUpdateAndEdit">
    <button nz-button nzType="primary" type="submit" (click)="updateAndEditPopup($event)" [disabled]="isDisableUpdate">Sửa</button>
  </ng-container>
  <ng-container *ngIf="isUpdateAndClose">
    <button nz-button nzType="primary" type="submit" (click)="updateAndClosePopup($event)" [disabled]="isDisableUpdate">Lưu & đóng</button>
  </ng-container>

</div>